import React from 'react';
import { Tag, Space } from 'antd';
import { useDarkMode } from 'src/context/DarkModeContext';


interface TopicSelectorProps {
    topics: string[];
    selectedTheme: string;
    onThemeChange: (value: string) => void;
}

const TopicSelector: React.FC<TopicSelectorProps> = ({
    topics,
    selectedTheme,
    onThemeChange,
}) => {
    const { isDarkMode } = useDarkMode();

    return (
        <div>
            <Space wrap style={{ marginBottom: '25px' }}>
                {topics.map((theme) => (
                    <Tag
                        key={theme}
                        color={theme === selectedTheme ? 'geekblue' : 'default'}
                        className={isDarkMode ? 'dark' : ''}
                        style={{
                            cursor: 'pointer',
                            fontSize: 14,
                            padding: '6px 12px',
                            borderRadius: 16,
                            userSelect: 'none',
                        }}
                        onClick={() => onThemeChange(theme)}
                    >
                        {theme}
                    </Tag>
                ))}
            </Space>
        </div>
    );
};

export default TopicSelector;
